import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { Button, Card, InputWrapper, Modal, ModalCloseButton, SectionText } from '..';
import * as Styled from './styled';
import type { ConfirmationModalProps } from './types';

export * from './types';

export const ConfirmationModal: FC<ConfirmationModalProps> = (props) => {
  const { translate } = useTranslation();
  const {
    modal,
    onConfirm,
    onCancel = modal.onCloseClick,
    text,
    title = translate('glossary.confirmation'),
    confirmText = translate('common.buttons.confirm'),
    cancelText = translate('common.buttons.cancel'),
    loading = false,
  } = props;

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <Styled.Container>
          <Styled.ModalSectionTitle>{title}</Styled.ModalSectionTitle>
          {text && typeof text === 'string' ? (
            <SectionText dangerouslySetInnerHTML={{ __html: text }} />
          ) : (
            <SectionText>{text}</SectionText>
          )}

          <Styled.ButtonsContainer>
            <InputWrapper split>
              <Button color="blue" outlined onClick={onCancel} disabled={loading}>
                {cancelText}
              </Button>
            </InputWrapper>
            <InputWrapper split last>
              <Button color="blue" onClick={onConfirm} loading={loading}>
                {confirmText}
              </Button>
            </InputWrapper>
          </Styled.ButtonsContainer>
        </Styled.Container>
      </Card>
    </Modal>
  );
};
